import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';

import { useForm, FormProvider } from 'react-hook-form';

import { Typography } from '@mui/material';

import { ContentToggler } from './Container';

import { AuthAlternative, Error, LinkStyled } from './styles';
import {
  ButtonStyled,
  DialogContentStyled,
  DialogActionsStyled,
} from 'elements/mismosh';
import { TextFieldFormStyled } from 'elements/formTextField';

import { confirmForgotPasswordCode } from 'components/authorization/cognitoUtils';
import { handleSwitchTemplate, handleCloseTemplate } from './switchHandlers';
import { Password } from './password';

type FormData = { code: string; password: string };

interface Props {
  switchToClose: ContentToggler;
  switchToSendCode: ContentToggler;
  username: string;
}

export const ForgotPasswordSubmitCode: React.FC<Props> = ({
  switchToClose,
  switchToSendCode,
  username,
}) => {
  const [apiError, setApiError] = useState('');
  const methods = useForm<FormData>({
    defaultValues: { code: '', password: '' },
  });

  const handleClose = handleCloseTemplate(switchToClose);
  const handleGotoSendCode = handleSwitchTemplate(
    switchToSendCode,
    handleClose,
  );

  const onSubmit = async (
    { code, password }: FormData,
    e: React.SyntheticEvent,
  ) => {
    e.preventDefault();
    try {
      await confirmForgotPasswordCode(username, code, password);
      setApiError(undefined);
      handleClose();
    } catch (err) {
      setApiError(err?.message);
      console.log('error...: ', err);
    }
  };

  const { ref: refCode, ...restCode } = methods.register('code', {
    required: true,
  });

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <DialogTitle id="signin-modal">Reset Password</DialogTitle>
          <DialogContentStyled>
            <TextFieldFormStyled
              {...restCode}
              inputRef={refCode}
              label="Code"
            />
            {methods.formState.errors.code && <Error>Field is required</Error>}

            <Password label="New Password"></Password>

            {!!apiError && <Error>{apiError}</Error>}
          </DialogContentStyled>
          <DialogActionsStyled>
            <ButtonStyled
              name="forgot-password-submit-submit"
              variant="contained"
              color="primary"
              type="submit"
            >
              Reset
            </ButtonStyled>
          </DialogActionsStyled>
          <AuthAlternative>
            <Typography variant="caption">Don&#39;t have a code?</Typography>
            <LinkStyled onClick={handleGotoSendCode}>
              Resend to phone
            </LinkStyled>
          </AuthAlternative>
        </form>
      </FormProvider>
    </Dialog>
  );
};
